import {useEffect, useState} from "react";
import {EnglishToPersian} from "numeral-convert";
import {useSelector} from "react-redux";
import {selectWaterType} from "../features/request/requestSlice";
import {selectCallApi} from "../features/common-states/commonStatesSlice";

const Pagination = ({handleChangePage}) => {
    const [selectedItem, setSelectedItem] = useState(1)
    const waterType = useSelector(selectWaterType)
    const callApi = useSelector(selectCallApi)
    const array = [1, 2, 3, 4, 5];
    const handleClick = (e, item) => {
        if(item === 0 || item === 6){
            return
        }
        setSelectedItem(item)
        handleChangePage(item)
    }

    useEffect(() => {
        if(selectedItem !== 1){
            setSelectedItem(1)
        }
        // eslint-disable-next-line
    }, [waterType, callApi]) // waterType is only for RequestManagement

    return(
        <div className='pagination-box'>
            <div onClick={(e) => handleClick(e, selectedItem - 1)}><span>قبلی</span><i className="fa fa-angle-double-right"></i></div>
            {array.map((item, index) => {
                return <div key={index} onClick={(e) => handleClick(e, item)} style={selectedItem === item ? {backgroundColor: 'limegreen', color: 'white'}: {}}>{EnglishToPersian(item.toString())}</div>
            })}
            <div onClick={(e) => handleClick(e, selectedItem + 1)}><i className="fa fa-angle-double-left"></i><span>بعدی</span></div>
        </div>
    )
}

export default Pagination